var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M26.25 11.25V4.52637C26.25 4.02891 26.0525 3.55254 25.701 3.20039L23.049 0.549023C22.6975 0.197461 22.2205 0 21.723 0H5.625C4.58965 0 3.75 0.839648 3.75 1.875V11.25C1.67871 11.25 0 12.9287 0 15V21.5625C0 22.0805 0.419531 22.5 0.9375 22.5H3.75V28.125C3.75 29.1604 4.58965 30 5.625 30H24.375C25.4104 30 26.25 29.1604 26.25 28.125V22.5H29.0625C29.5805 22.5 30 22.0805 30 21.5625V15C30 12.9287 28.3213 11.25 26.25 11.25ZM22.5 26.25H7.5V20.625H22.5V26.25ZM22.5 13.125H7.5V3.75H18.75V6.5625C18.75 7.08047 19.1695 7.5 19.6875 7.5H22.5V13.125ZM25.3125 17.3438C24.5361 17.3438 23.9062 16.7139 23.9062 15.9375C23.9062 15.1605 24.5361 14.5312 25.3125 14.5312C26.0889 14.5312 26.7188 15.1605 26.7188 15.9375C26.7188 16.7139 26.0889 17.3438 25.3125 17.3438Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }